export default "__VITE_ASSET__b0c4e028__"